export const API_CONFIG = {
    BASE_URL: '/flight/api/v1/flight-change-cases',
    TIMEOUT: 30000,
    RETRY_ATTEMPTS: 3
} as const;

export const X_TOTAL_ELEMENTS_HEADER = 'X-total-elements';

export const ERROR_MESSAGES = {
    UNAUTHORIZED: 'UNAUTHORIZED',
    SERVER_ERROR: 'SERVER_ERROR',
    FETCH_FAILED: 'Failed to fetch flights',
    NOT_FOUND: 'NOT_FOUND'
} as const;

export const AUTO_REFRESH_CONFIG = {
    INTERVAL_TIME_MS: 2 * 60 * 1000,
    MAX_UPDATES: 5,
    TOTAL_DURATION_MS: 10 * 60 * 1000
} as const;

